module.exports = __webpack_public_path__ + "images/128x128.png";